// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"452":"fd04af1b","952":"0a1b9d6c"}[chunkId] + ".chunk.css";
};